export default {
  not_started: 'Configurează-ți contul de plată — cota ta din venituri este blocată până la verificare.',
  bank_account_missing: 'Adaugă un cont bancar pentru plăți — cota ta din venituri este blocată până o faci.',
  incomplete: 'Contul tău de plată nu este verificat complet încă — cota ta din venituri este blocată până atunci.',
  add_bank_account: 'Adaugă cont bancar',
  cta: 'Finalizează configurarea',
};
